"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("../styles"));
var _StepLabel = _interopRequireDefault(require("@mui/material/StepLabel"));
var _Step = require("@mui/material/Step");
var _Warning = _interopRequireDefault(require("@ellucian/ds-icons/lib/Warning"));
var _WarningSolid = _interopRequireDefault(require("@ellucian/ds-icons/lib/WarningSolid"));
var _tokens = require("../styles/tokens");
var _Typography = _interopRequireDefault(require("../Typography"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _EDSContext = require("../EDSContext/EDSContext");
var _constants = require("./internal/constants.js");
var _StepProgressContext = _interopRequireDefault(require("./internal/StepProgressContext"));
var _ChevronDown = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronDown"));
var _ChevronUp = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronUp"));
var _excluded = ["className", "classes", "children", "error", "optional", "StepIconProps", "edsContext"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  var _stepLabelActiveOrCom;
  return {
    labelRoot: {
      fontFamily: theme.typography.body1.fontFamily,
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
      lineHeight: theme.typography.body1.lineHeight,
      color: theme.palette.grey[500],
      flexGrow: 4
    },
    root: {
      width: '100%',
      padding: 0
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    stepIconRoot: {
      color: theme.palette.grey[100],
      borderRadius: '100%',
      width: _tokens.spacing60,
      height: _tokens.spacing60,
      marginLeft: '-0.187rem',
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[500],
      '& > text': {
        fontSize: '0.75rem',
        fontWeight: _tokens.fontWeightBold,
        textAnchor: 'middle'
      },
      '&$stepIconActive': {
        border: 'none',
        color: theme.palette.ctaColor.base,
        '&> text': {
          color: theme.palette.grey[100],
          fill: theme.palette.grey[100]
        }
      }
    },
    stepIconText: {
      fill: theme.palette.grey[500]
    },
    stepIconActive: {
      color: theme.palette.ctaColor.base
    },
    stepIconEnable: {
      color: theme.palette.grey[500]
    },
    stepIconCustomRoot: {
      border: 'none',
      width: _tokens.sizingMedium,
      height: _tokens.sizingMedium,
      verticalAlign: 'middle'
    },
    stepIconError: {
      color: theme.palette.status.error.fill,
      fill: theme.palette.status.error.fill,
      width: _tokens.spacing60,
      height: _tokens.spacing60
    },
    stepIconCompleted: {
      color: theme.palette.ctaColor.base,
      fill: theme.palette.ctaColor.base
    },
    stepIconDisabled: {
      '& svg': {
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
        '& > text': {
          fill: theme.palette.grey[400]
        }
      }
    },
    stepLabelDisabled: {
      color: theme.palette.grey[400],
      fontWeight: _tokens.fontWeightNormal
    },
    stepLabelActiveOrCompleted: (_stepLabelActiveOrCom = {}, _stepLabelActiveOrCom["& ." + _constants.STEP_LABEL_CLASSNAME] = {
      color: theme.palette.grey[600],
      fontWeight: _tokens.fontWeightBold
    }, _stepLabelActiveOrCom["& ." + _constants.STEP_LABEL_CLASSNAME + "$labelError"] = {
      color: theme.palette.status.error.fill
    }, _stepLabelActiveOrCom),
    labelError: {
      color: theme.palette.status.error.fill,
      flexGrow: 1
    },
    expansionIcon: {
      paddingLeft: '8px',
      display: 'flex',
      alignItems: 'center',
      fill: theme.palette.grey[500]
    },
    expansionIconOpen: {
      fill: theme.palette.grey[400]
    },
    expansionIconContainer: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        fontSize: _tokens.fontSizeHeader2
      }
    }
  };
};

/**
 * A component that displays progress through numbered steps.
 */
var StepLabel = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _cn;
  var className = props.className,
    classes = props.classes,
    children = props.children,
    error = props.error,
    optional = props.optional,
    StepIconProps = props.StepIconProps,
    edsContext = props.edsContext,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _useContext = (0, _react.useContext)(_StepProgressContext.default),
    expansion = _useContext.expansion,
    alternativeLabel = _useContext.alternativeLabel;
  var _useContext2 = (0, _react.useContext)(_Step.StepContext),
    active = _useContext2.active,
    disabled = _useContext2.disabled;
  var defaultOverrides = {
    StepIconProps: (0, _extends2.default)({
      classes: {
        root: classes.stepIconRoot,
        text: classes.stepIconText,
        active: classes.stepIconActive,
        completed: classes.stepIconActive,
        error: classes.stepIconError
      }
    }, StepIconProps)
  };
  var expansionIcon = function expansionIcon() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: classes.expansionIcon
    }, active ? /*#__PURE__*/_react.default.createElement(_ChevronUp.default, {
      className: classes.expansionIconOpen
    }) : /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      title: edsContext.formatMessage('component.StepProgress.open'),
      enterDelay: 1000,
      enterNextDelay: 1000
    }, /*#__PURE__*/_react.default.createElement(_ChevronDown.default, null)));
  };

  // if the current error step, replace the icon
  var overrideErrorIcon = (0, _react.useCallback)(function (flag) {
    return flag ? /*#__PURE__*/_react.default.createElement(_WarningSolid.default, {
      className: (0, _classnames.default)(classes.stepIconError, classes.stepIconCustomRoot)
    }) : /*#__PURE__*/_react.default.createElement(_Warning.default, {
      className: (0, _classnames.default)(classes.stepIconError, classes.stepIconCustomRoot)
    });
  }, [classes.stepIconCustomRoot, classes.stepIconError]);
  defaultOverrides.optional = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body3",
    color: "textSecondary",
    align: alternativeLabel ? 'center' : 'left',
    classes: {
      body3: !error && disabled && classes.stepLabelDisabled
    },
    className: expansion ? classes.expansionIconContainer : null
  }, optional, !expansion ? null : expansionIcon()));
  if (error) {
    // Assign new error icon
    defaultOverrides.StepIconProps.icon = overrideErrorIcon(active);

    // if error is a string make the optional prop print the error message
    if (error.length > 0) {
      /* These marker class names will be used by its parent component StepProgress */
      defaultOverrides.optional = /*#__PURE__*/_react.default.createElement("div", {
        className: classes.expansionIconContainer
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body3",
        className: (0, _classnames.default)(classes.labelError, _constants.STEP_LABEL_ERROR_CLASSNAME),
        align: alternativeLabel ? 'center' : 'left'
      }, error), !expansion ? null : expansionIcon());
    }
  }
  var classOverrides = {
    active: classes.stepLabelActiveOrCompleted,
    completed: classes.stepLabelActiveOrCompleted,
    disabled: !error && classes.stepIconDisabled
  };
  if (expansion) {
    classOverrides = Object.assign(classOverrides, {
      labelContainer: classes.labelContainer,
      root: classes.root
    });
  }
  return /*#__PURE__*/_react.default.createElement(_StepLabel.default, (0, _extends2.default)({}, defaultOverrides, {
    classes: classOverrides,
    className: (0, _classnames.default)(className, _constants.STEP_LABEL_CONTAINER_CLASSNAME)
  }, rest, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.labelRoot, "" + _constants.STEP_LABEL_CLASSNAME, (_cn = {}, _cn[classes.labelError] = error, _cn[_constants.STEP_LABEL_HAS_ERROR_CLASSNAME] = error, _cn[classes.stepLabelDisabled] = !error && disabled, _cn))
  }, children));
});
StepLabel.muiName = 'StepLabel';
StepLabel.displayName = 'StepLabel';
StepLabel.propTypes = {
  /**
   * @ignore
   */
  StepIconProps: _propTypes.default.object,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,
  /**
   * Used to mark the step in an error state and provide an error message.
   */
  error: _propTypes.default.any,
  /**
   * Override the default text label of the step icon.
   */
  icon: _propTypes.default.node,
  /**
   * The optional text to display.
   */
  optional: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
StepLabel.defaultProps = {
  error: false
};
var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(StepLabel));
exports.default = _default;